type incomingAboutMeData = {
  title: string;
  role: string;
  description: string;
};

export const aboutMeData: incomingAboutMeData = {
  title: "Hello, I'm Phuc.",
  role: 'A  software developer.',
  description:
    'I primarily focus on writing clean, elegant and efficient code. I am proficient in JavaScript, TypeScript, SASS, ReactJS, etc. I also review existing code and can consult with you on how to improve it. Over nearly two years, I have primarily worked for companies that specialize in enterprise web applications.',
};
